module.exports = __webpack_public_path__ + "media/send.105a92d3.mp3";